/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Dash_Url_LabelInputs */



/**
* | output |
* | --- |
* | "DASH Manifest URL" |
*
* @param {New_Project_Dash_Url_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_dash_url_label = /** @type {((inputs?: New_Project_Dash_Url_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Dash_Url_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URL du manifeste DASH")
	if (locale === "de") return /** @type {LocalizedString} */ ("DASH-Manifest-URL")
	if (locale === "it") return /** @type {LocalizedString} */ ("URL manifesto DASH")
	if (locale === "ru") return /** @type {LocalizedString} */ ("URL манифеста DASH")
	if (locale === "es") return /** @type {LocalizedString} */ ("URL del manifiesto DASH")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("DASH清单URL")
	if (locale === "ja") return /** @type {LocalizedString} */ ("DASHマニフェストURL")
	if (locale === "hi") return /** @type {LocalizedString} */ ("DASH मैनिफेस्ट URL")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("URL do manifesto DASH")
	return /** @type {LocalizedString} */ ("DASH Manifest URL")
});